var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaqLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66602 5.33325C2.66602 3.44792 2.66602 2.50459 3.25202 1.91925C3.83735 1.33325 4.78068 1.33325 6.66602 1.33325H9.33268C11.218 1.33325 12.1613 1.33325 12.7467 1.91925C13.3327 2.50459 13.3327 3.44792 13.3327 5.33325V10.6666C13.3327 12.5519 13.3327 13.4953 12.7467 14.0806C12.1613 14.6666 11.218 14.6666 9.33268 14.6666H6.66602C4.78068 14.6666 3.83735 14.6666 3.25202 14.0806C2.66602 13.4953 2.66602 12.5519 2.66602 10.6666V5.33325Z",
    stroke: "black",
    strokeOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2647 10.6665H5.26468C4.64468 10.6665 4.33468 10.6665 4.08002 10.7345C3.74089 10.8254 3.43168 11.0041 3.18347 11.2524C2.93526 11.5007 2.75679 11.81 2.66602 12.1492",
    stroke: "black",
    strokeOpacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33203 4.6665H10.6654M5.33203 6.99984H8.66536",
    stroke: "black",
    strokeOpacity: 0.7,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqLight);
export default __webpack_public_path__ + "static/media/faqLight.fac7a7d30f34498ef0dba6d95b3adb02.svg";
export { ForwardRef as ReactComponent };